import React, { useState } from "react";

export default function SignInPanel() {
  // Render nothing
  return null;
} 